export enum EBusinessStructureUserSearchWarning {
  NOT_VERIFIED = "NOT_VERIFIED",
  ALREADY_ASSIGNED_AS_KEY_MANAGER = "ALREADY_ASSIGNED_AS_KEY_MANAGER",
  ALREADY_ASSIGNED_AS_OWNER = "ALREADY_ASSIGNED_AS_OWNER",
}
